'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities');

var GRAPHS = config.graphs;

var chartId = 'TOP_CUSTOMER_USING_DATA',
    chartType = 'TOP_N',
    filters = [config.filters.DURATION],
    dimensions = {
        CUSTOMER: 'customer'
    },
    dataSeries = {
        TIMESTAMP: 'timestamp',
        CUSTOMER: 'customer',
        TOTAL_DATA: 'totalData',
        GUEST_DATA: 'guestData',
        CORPORATE_DATA: 'nonGuestData'
    },
    fieldNames = {
        CUSTOMER: 'customer',
        GUEST_DATA: 'amcApTrafficOverGuestSsidInKbs',
        CORPORATE_DATA: 'amcApTrafficOverNonGuestSsidInKbs'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'topN',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimension: dimensions.CUSTOMER,
        threshold: 5,
        metric: dataSeries.TOTAL_DATA,
        granularityOverride: GRAPHS.GLOBAL.GRANULARITY_ALL,
        aggregations: [{
            'type': 'longSum',
            'name': dataSeries.GUEST_DATA,
            'fieldName': fieldNames.GUEST_DATA
        }, {
            'type': 'longSum',
            'name': dataSeries.CORPORATE_DATA,
            'fieldName': fieldNames.CORPORATE_DATA
        }],
        postAggregations: [{
            'type': 'arithmetic',
            'name': dataSeries.TOTAL_DATA,
            'fn': '+',
            'fields': [{
                'type': 'fieldAccess',
                'name': dataSeries.GUEST_DATA,
                'fieldName': dataSeries.GUEST_DATA
            }, {
                'type': 'fieldAccess',
                'name': dataSeries.CORPORATE_DATA,
                'fieldName': dataSeries.CORPORATE_DATA
            }]
        }]
    }],
    dataSeriesFields = null,
    modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
    tasks = [
        'durationFilter',
        'druidQueryGenerator',
        'druidQueryValidator',
        'fetchChartData',
        'druidResponseParser',
        'transformResponseToObject', {
            name: 'convertToCustomerName',
            config: {
                customerApiGetUrl: config.restApi.relativePath.customersInfo,
                customerNameField: fieldNames.CUSTOMER,
                GETQueryKey: 'customerId'
            }
        }, {
            plugin: modifyResponse
        }, {
            name: 'updateChartModelData',
            config: {
                dataSeriesFields: dataSeriesFields,
                modelFieldKeys: modelFieldKeys
            }
        }
    ];

exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.TOP_CUSTOMERS_USING_DATA;

function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {};
    _.forEach(_.values(dataSeries), function(seriesName) {
        computedModel[seriesName] = model[seriesName];
    });

    context.chartData = computedModel;
    next();
}

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
        pointWidth = width / 50;

    var xAxisFormatter = $u.charts.chartXaxisEllipsis,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
        xAxisMaxChars = 12,
        yAxisBaseUnit = 'KB',
        yAxisRoundOff = false,
        yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            chartType: 'topN',
            duration: duration,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces,
            xAxisDataHeader: 'Customer Name',
            xAxisMaxChars: null //null means do not put ellipsis in customer name.
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), 'KB').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax,
                        yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0} {1}: <b>{2}{3}</b> <br /> {4}: {5}',
                    this.series.name,
                    'Data Usage',
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit,
                    'Customer',
                    this.x
                );
            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data[dataSeries.CUSTOMER],
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return xAxisFormatter(xAxisMaxChars, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            min: 0,
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1,
            title: {
                text: '',
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;

                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            stackLabels: {
                enabled: false,
                style: {
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            }
        }],
        plotOptions: {
            column: {
                stacking: 'normal',
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth,
                events: {
                    legendItemClick: function() {
                        var dataUnit,
                            legendContext = this,
                            legendIndex = legendContext.index,
                            dataArray = [];

                        _.forEach(legendContext.chart.legend.allItems, function(legendItem) {
                            if (legendItem.index === legendIndex) {
                                if (!legendItem.visible) {
                                    dataArray.push(_.max(legendItem.yData));
                                }
                            } else {
                                if (legendItem.visible) {
                                    dataArray.push(_.max(legendItem.yData));
                                }
                            }
                        });

                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), 'KB').unit;

                        legendContext.yAxis.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    }
                }
            }
        },
        series: [{
            name: 'Guest',
            data: data[dataSeries.GUEST_DATA],
            color: GRAPHS.GLOBAL.COLORS.MOJO_RED,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_RED
        }, {
            name: 'Corporate',
            data: data[dataSeries.CORPORATE_DATA],
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        }, {
            type: 'spline',
            name: 'Total',
            data: data[dataSeries.TOTAL_DATA],
            color: GRAPHS.GLOBAL.COLORS.CHART_GREEN,
            marker: {
                lineWidth: 1,
                lineColor: GRAPHS.GLOBAL.COLORS.MOJO_BLACK,
                fillColor: GRAPHS.GLOBAL.COLORS.MOJO_BLACK,
                radius: width / 400 + 1
            }
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
